import { initData } from "@telegram-apps/sdk-react"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { useDimension } from "../store/dimensions-store"

export const useHandleRedirect = () => {
  const navigate = useNavigate()
  const isRedirected = useDimension((state) => state.isRedirected)
  const setIsRedirected = useDimension((state) => state.setIsRedirected)

  useEffect(() => {
    if (isRedirected) return

    if (initData?.startParam()?.includes("page")) {
      const path = initData?.startParam()?.split("-")
      navigate(path ? `/${path[1]}` : "/")
      setIsRedirected(true)
    }
  }, [navigate])
}
